@if (isLoading()) {
  <div class="flex justify-center py-16">
    <casa-doc-loader></casa-doc-loader>
  </div>
} @else {
  <section class="wizard-shell">
    @switch (uiState()) {
      @case ('upload') {
        <casa-doc-upload-preview-step
          [files]="fileControl.value"
          (filesChange)="onFilesChange($event)"
          (proceed)="onUploadProceed()"
        ></casa-doc-upload-preview-step>
      }

      @case ('configuring') {
        <casa-doc-style-selection-step
          [filesCount]="filesCount()"
          [styles]="styles"
          [furnitureStyle]="furnitureStyle()"
          [removeFurniture]="removeFurnitureControl.value"
          [removePersonalEffects]="removePersonalEffectsControl.value"
          [addCompanyLogo]="addCompanyLogoControl.value"
          [showCompanyOption]="canAddCompanyLogo()"
          [canProceed]="canProcess()"
          (back)="onBackToUpload()"
          (furnitureStyleChange)="onFurnitureStyleChange($event)"
          (removeFurnitureChange)="onRemoveFurnitureChange($event)"
          (removePersonalEffectsChange)="onRemovePersonalEffectsChange($event)"
          (addCompanyLogoChange)="onAddCompanyLogoChange($event)"
          (proceed)="onProceedToGeneration()"
        ></casa-doc-style-selection-step>
      }

      @case ('generation') {
        <casa-doc-generation-step
          [processedImages]="processedImages()"
          [previewModes]="previewModes"
          [previewMode]="previewMode()"
          [canDownload]="canDownload()"
          [hasPending]="hasPending()"
          [quotaExhausted]="quotaExhausted()"
          [isGenerating]="isGenerating()"
          [limitWarning]="limitWarning()"
          [showPromptDebug]="isPromptDebugEnabled()"
          [promptPreviews]="promptPreviews()"
          [addCompanyLogo]="addCompanyLogoControl.value"
          [showCompanyOption]="canAddCompanyLogo()"
          (back)="onBackToStyle()"
          (restart)="onRestart()"
          (previewModeChange)="setPreviewMode($event)"
          (download)="onDownloadZip()"
          (processAll)="onProcessAll()"
          (generateOne)="onGenerateOne($event)"
          (configChange)="onPhotoConfigChange($event.index, $event.config)"
          (editImage)="onEditImage($event.index, $event.editPrompt)"
          (addCompanyLogoChange)="onAddCompanyLogoChange($event)"
        ></casa-doc-generation-step>
      }
    }
  </section>

  <casa-doc-confirm-dialog
    [open]="!!confirmDialog()"
    [title]="confirmDialog()?.title ?? ''"
    [message]="confirmDialog()?.message ?? ''"
    [confirmLabel]="confirmDialog()?.confirmLabel ?? 'Conferma'"
    (confirm)="onConfirmDialog()"
    (cancel)="onCancelDialog()"
  ></casa-doc-confirm-dialog>
}
